import { ICarRentalSearchBarState } from './state';

export enum CarRentalSearchBarActionType {
  SET_DEPERATURE = 'SET_DEPERATURE',
  SET_ARRIVAL = 'SET_ARRİVAL',
  SET_PICK_UP_DATE = 'SET_PICK_UP_DATE',
  SET_DROP_UP_DATE = 'SET_DROP_UP_DATE',
  SET_PICK_UP_TIME = 'SET_PICK_UP_TIME',
  SET_DROP_UP_TIME = 'SET_DROP_UP_TIME',
  SET_IS_DIFFERENT_LOCATION = 'SET_IS_DIFFERENT_LOCATION',
}

export interface SetPickUpDate {
  type: CarRentalSearchBarActionType.SET_PICK_UP_DATE;
  payload: ICarRentalSearchBarState['pickUpDate' | 'dropUpDate'];
}

export interface SetDropUpDate {
  type: CarRentalSearchBarActionType.SET_DROP_UP_DATE;
  payload: ICarRentalSearchBarState['dropUpDate'];
}

export interface SetPickUpTime {
  type: CarRentalSearchBarActionType.SET_PICK_UP_TIME;
  payload: ICarRentalSearchBarState['pickUpTime' | 'dropUpTime'];
}

export interface SetDropUpTime {
  type: CarRentalSearchBarActionType.SET_DROP_UP_TIME;
  payload: ICarRentalSearchBarState['dropUpTime'];
}
export interface SetArrival {
  type: CarRentalSearchBarActionType.SET_ARRIVAL;
  payload: ICarRentalSearchBarState['arrival'];
}
export interface SetDeperature {
  type: CarRentalSearchBarActionType.SET_DEPERATURE;
  payload: ICarRentalSearchBarState['departure'];
}

export interface SetIsDifferentLocation {
  type: CarRentalSearchBarActionType.SET_IS_DIFFERENT_LOCATION;
  payload: ICarRentalSearchBarState['isDifferentLocation'];
}

export type CarRentalSearchBarActions =
  | SetPickUpDate
  | SetDropUpDate
  | SetPickUpTime
  | SetDropUpTime
  | SetArrival
  | SetDeperature
  | SetIsDifferentLocation;
